import { render, staticRenderFns } from "./component.vue?vue&type=template&id=528d1eb3&scoped=true&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"
import style0 from "./component.vue?vue&type=style&index=0&id=528d1eb3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528d1eb3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/projects/pes-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('528d1eb3')) {
      api.createRecord('528d1eb3', component.options)
    } else {
      api.reload('528d1eb3', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=528d1eb3&scoped=true&", function () {
      api.rerender('528d1eb3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/resource/component/file/list/component.vue"
export default component.exports